import { atAGlanceRows } from "@/lib/cardFacts";

interface CardAtAGlanceProps {
  card: any;
  className?: string;
}

/**
 * "Auf einen Blick" — the key facts of a card as a plain label/value list.
 * Values come only from stored provider data; rows without data are omitted
 * upstream in atAGlanceRows().
 */
export function CardAtAGlance({ card, className = "" }: CardAtAGlanceProps) {
  const rows = atAGlanceRows(card);
  if (rows.length === 0) return null;

  return (
    <section className={`bg-white rounded-xl p-6 border border-gray-200 ${className}`}>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Auf einen Blick</h2>
      <dl className="divide-y divide-gray-100">
        {rows.map((row) => (
          <div key={row.label} className="flex flex-wrap justify-between gap-2 py-2">
            <dt className="text-gray-600" title={row.hint}>
              {row.label}
            </dt>
            <dd className="font-medium text-gray-900 text-right">{row.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
